import React from "react";
import ReactDOM from "react-dom";
import Loading from "./loading";
var container = null,
  loading = null,
  duration = 200;
export default {
  mask: false,
  Element: Loading,
  config: function (_a) {
    var _b = _a.mask,
      mask = _b === void 0 ? false : _b;
    this.mask = mask;
  },
  show: function (loadingParams) {
    if (container) return;
    var loadingText = loadingParams === null || loadingParams === void 0 ? void 0 : loadingParams.loadingText;
    container = document.createElement("div");
    container.className = "iweb-loading";
    document.body.appendChild(container);
    ReactDOM.render( /*#__PURE__*/React.createElement(Loading, {
      mask: this.mask,
      visible: true,
      loadingText: loadingText
    }), container, function () {
      loading = this;
    });
  },
  hide: function () {
    if (!container) return;
    loading && loading.addEnterStyle();
    window.setTimeout(function () {
      container && ReactDOM.unmountComponentAtNode(container);
      container && document.body.removeChild(container);
      container = null;
    }, duration);
  }
};